import { Route } from "react-router-dom";

import { AuthenticateGuard } from "@/components/AuthenticateGuard/AuthenticateGuard";
import { TemplateKazaarPage } from "@/pages/TemplateKazaarPage";
import { SimplePage } from "@/pages/TemplateKazaarPage/SimplePage";

export const sharedRoutes = [
  <Route
    key="403-route"
    path="403"
    element={
      <TemplateKazaarPage>
        <SimplePage state="403" />
      </TemplateKazaarPage>
    }
  />,
  <Route
    key="401-route"
    path="401"
    element={
      <TemplateKazaarPage>
        <SimplePage state="401" />
      </TemplateKazaarPage>
    }
  />,
  <Route
    key="expired-route"
    path="expired"
    element={
      <TemplateKazaarPage>
        <SimplePage state="expired" />
      </TemplateKazaarPage>
    }
  />,
  <Route
    key="404-route"
    path="*"
    element={
      <AuthenticateGuard>
        <TemplateKazaarPage>
          <SimplePage state="404" />
        </TemplateKazaarPage>
      </AuthenticateGuard>
    }
  />,
];
